module.exports = __webpack_public_path__ + "img/list20.863f65ec.png";